<template>
  <div class="page">
    <div class="search">
      <div class="search-box">
        <div style="width: 86%">
          <form @submit.prevent="formSubmit" action="javascript:return true">
            <input ref="searchInput" v-model="searchTerm" type="text" placeholder="请输入您要查询的内容"
                   class="search-input" @keydown="search2($event)"/>
          </form>
        </div>
        <span class="cancel" @click="cancel" v-if="searchTerm !== ''">
          <img src="../assets/img/close.png"/>
        </span>
        <div style="width: 10%">
          <button onClick="history.back();">取消</button>
        </div>
      </div>
      <div v-show="showResults" class="results" style="background-color: transparent;">
        <template v-if="results.length > 0">
          <div v-for="(result, index) in results" :key="index">

            <van-collapse v-model="activeNames" accordion :border="false">
              <van-collapse-item :title="result.question"
                                 :title-class="activeNames ===result.activeNames ? 'checked-title' :'unchecked'"
                                 :name="result.activeNames"
                                 :icon="activeNames===result.activeNames  ? 'circle2 iconfont' :'circle'"
                                 :is-link="true">
                <div class="item-content" style="background-color: transparent;">
                  <p v-html="formatContent(result.answer)"  @click="handleContentClick"></p>
                  <!--                    <div style="height: 10px"></div>-->
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </template>
<!--        <img v-else src="../assets/img/none.png" alt="None" class="none">-->
        <span v-else>
          <img src="../assets/img/none_new.png" alt="None" class="none">
          <p class="no-content-text">暂无相关内容</p>
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
export default {
  data() {
    return {
      activeNames: '',
      searchTerm: "",
      results: [],
      showResults: false,
      gender:2,
      app_id: 1,
      imAction : {
        1:['做任务', 'toDayTask'],
        2:['每日任务', 'toDayTask'],
        3:['贵族','toVip'],
        4: ['贵族特享', 'toVip'],
        5:['真人认证', 'toRealPerson'],
        6:['金币清单', 'toGoldBill'],
        7:['积分清单', 'toIntegralBill'],
        8:['收费设置', 'toMoneySetting'],
        9:['上传头像', 'toAvatar'],
        10:['在线客服', 'toCustomer'],
        11:['消费记录', 'toIntegralBill'],
        12:['积分兑换', 'toIntegral'],
        13:['陌生约聊平台用户行为规范', 'userAgent'],
        14:['编辑语音签名', 'toVoiceFlag'],
        15:['温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。', 'toSign']
      }
    };
  },
  name: "Search",
  methods: {
    formatContent(content) {
      if (!content) return '';
      return content.replace(/(做任务|每日任务|贵族|贵族特享|真人认证|金币清单|积分清单|收费设置|上传头像|在线客服|消费记录|积分兑换|陌生约聊平台用户行为规范|编辑语音签名|温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。)/g, match => {
        return `<span class="highlight-action" style="color:cornflowerblue;cursor:pointer;">${match}</span>`;
      });
    },

    handleContentClick(e) {
      if (e.target.classList.contains('highlight-action')) {
        const text = e.target.innerText;
        switch (text) {
          case this.imAction[1][0]:
            this.handleSpanClick(this.imAction[1][1])
            break;
          case this.imAction[2][0]:
            this.handleSpanClick(this.imAction[2][1])
            break;
          case this.imAction[3][0]:
            this.handleSpanClick(this.imAction[3][1])
            break;
          case this.imAction[4][0]:
            this.handleSpanClick(this.imAction[4][1])
            break;
          case this.imAction[5][0]:
            this.handleSpanClick(this.imAction[5][1])
            break;
          case this.imAction[6][0]:
            this.handleSpanClick(this.imAction[6][1])
            break;
          case this.imAction[7][0]:
            this.handleSpanClick(this.imAction[7][1])
            break;
          case this.imAction[8][0]:
            this.handleSpanClick(this.imAction[8][1])
            break;
          case this.imAction[9][0]:
            this.handleSpanClick(this.imAction[9][1])
            break;
          case this.imAction[10][0]:
            this.handleSpanClick(this.imAction[10][1])
            break;
          case this.imAction[11][0]:
            this.handleSpanClick(this.imAction[11][1])
            break;
          case this.imAction[12][0]:
            this.handleSpanClick(this.imAction[12][1])
            break;
          case this.imAction[13][0]:
            this.handleSpanClick(this.imAction[13][1])
            break;
          case this.imAction[14][0]:
            this.handleSpanClick(this.imAction[14][1])
            break;
          case this.imAction[15][0]:
            this.handleSpanClick(this.imAction[15][1])
            break;
          default:
          // execute default code block
        }
      }
    },
    cancel() {
      this.showResults = false;
      this.searchTerm = '';

    },

    formSubmit() {
      return false
    },
    search() {
      this.showResults = true;
      this.results = [];
      var trimmedSearchTerm = this.searchTerm.trim().toLowerCase();



      if (trimmedSearchTerm !== "") {
        this.toSearch(trimmedSearchTerm)
        // for (var i = 0; i < this.questions.length; i++) {
        //   var question = this.questions[i];
        //
        //   if (this.gender==1 && question.activeNames == 171){
        //     continue
        //   }
        //
        //   if (
        //     question.question.toLowerCase().indexOf(trimmedSearchTerm) !== -1
        //   ) {
        //     this.results.push(question);
        //   }
        // }
      } else {
        this.results = [];
      }
    },
    search2(ev) {
      if (ev.keyCode == 13) {  //键盘回车的编码是13
        ev.preventDefault(); //阻止默认行为
        document.activeElement.blur(); //隐藏软键盘
        this.search();
      }
    },
    formatAnswer(answer) {
      return answer.replace(/\n/g, "<br>");

      // 将换行符（\n）替换为HTML的"<br>"标签

    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
    toSearch(title) {
      axios.get(process.env.BASE_API + '/feedbackAll', {'params':{'app_id': this.app_id, 'gender': this.gender, 'title':title}})
        .then(res => {
          if (res.data) {
            const resData = res.data.data
            const resultTemp = []

            resData.forEach(function (item, index, array) {
              resultTemp.push({
                'question': item.title,
                'answer': item.content,
                'activeNames':index
              })
            })

            this.results = resultTemp
          }
        })
        .catch(err => {
          console.error('请求feedbackAll接口失败:', err);
        });
    },
    getQueryParam(param) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');

      for (const item of vars) {
        const [key, value] = item.split('=');
        if (decodeURIComponent(key) === param) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
  },
  created() {
    this.gender  = this.getQueryParam('gender') === null ? 2 : parseInt(this.getQueryParam('gender'));
    this.app_id = this.getQueryParam('app_id') === null ? 1 : parseInt(this.getQueryParam('app_id'));
  },
  mounted() {
    this.$refs.searchInput.focus()
    const urlParams = new URLSearchParams(window.location.search);
    this.gender = urlParams.get('gender');
  }
};
</script>

<style>

.search-box {
  height: 30px;
  margin: 20px;
  margin-bottom: 1rem;
}

.search-box input {
  height: 35px;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px 0 10px;
  border: 1px solid #ddd;
}

.search-box button {
  position: absolute;
  top: 27px;
  right: 20px;
  width: auto;
  color: #939393;
  /*padding: 0.5rem 1rem;*/
  border: none;
  background-color: transparent;
  border-radius: 0.25rem;
  cursor: pointer;
}

.results h3 {
  font-size: 14px;
  margin-bottom: 0.5rem;
}

.results p {
  font-size: 13px;
  margin-bottom: 1rem;
}

.no-content-text {
  text-align: center;
  color: #999;
  font-size: 14px;
  margin-top: -90px;
}

.search-input {
  margin-right: 20px;
  background-color: transparent;
  border-radius: 10px;
  /*  background-image: url(../assets/img/R-C.png);
    background-repeat: no-repeat;
    background-position: 8px center;
    background-size: 7%;*/
  /*  text-indent: 30px;*/
}

.search-input::placeholder {
  padding-right: 20px;
}

.cancel {
  position: relative;
  top: -28px;
  right: -80%;
}

.cancel img {
  width: 20px;
}

.van-icon-circle2 {
  color: #3576F9;
}

.item-content {
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.none {
  width: 50%;
  height: 50%;
  margin: 25%;
}

.search-input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/page/Search.vue